export default ({ app }) => {
  app.router.afterEach((to, from) => {
    const categoryPattern = /^category-page/
    const foresightPattern = /^foresightPage/
    if (!categoryPattern.test(to.name) && !foresightPattern.test(to.name)) {
      app.store.dispatch('page/clearPageContent')
    }
  })
}
